<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <sui-panel :title="$t('MSG_TIT_COMP_BSIC_INFO')">
        <div class="comm_view_wrap">
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_GEHS_COMP_ID')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <div class="comm_label">
                {{ companyData.companyId }}
              </div>
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_NAT')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <div class="comm_label">
                {{ companyData.nationName }}
              </div>
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_CONN_COMP_CD')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <div class="comm_label">
                {{ companyData.connectionCompanyNumber }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_CORP_DSTG_NO')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <div class="comm_label">
                {{ companyData.corpRegNumber }}
              </div>
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_ERP_COMP_CD')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <div class="comm_label">
                {{ companyData.gerpCompanyNumber }}
              </div>
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_REG_STATUS')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <div class="comm_label">
                {{ companyData.companyRegistrationStateName }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_ACC_GRP_CD')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <div class="comm_label">
                {{ companyData.companyAccountGroupCode }}
              </div>
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_ACC_GRP')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <div class="comm_label">
                {{ companyData.companyAccountGroupName }}
              </div>
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_TRD_PSBL_YN')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <div class="comm_label">
                {{ companyData.companyTradePossibilityYn }}
              </div>
            </div>
          </div>
        </div>
      </sui-panel>
      <sui-panel :title="$t('MSG_TIT_BIZ_INFO')">
        <div class="comm_view_wrap">
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_COMP_LCL_NM')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-7">
              <div class="comm_label">
                {{ companyData.companyName }}
              </div>
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_BIZ_DIV')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <div class="comm_label">
                {{ companyData.bizDivisionCode }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_COMP_GLBL_NM')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-7">
              <div class="comm_label">
                {{ companyData.companyGlobalName }}
              </div>
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_RPRS_NM')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <div class="comm_label">
                {{ companyData.companyRepresentativeName }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_ESTB_DT')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <div class="comm_label">
                {{ companyData.companyEstablishDTM }}
              </div>
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_COMP_SCALE')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <div class="comm_label">
                {{ companyData.companyScaleValue }}
              </div>
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_AFCP_YN')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <div class="comm_label">
                {{ companyData.affiliatedCompanyDivisionCode }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_TCNT_EMPO')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <div class="comm_label">
                {{ companyData.companyEmpValue }}
              </div>
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_CBNO')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <div class="comm_label">
                {{ companyData.corpBizNumber }}
              </div>
            </div>
            <div class="col-xs-1 nodata" />
            <div class="col-xs-3" />
          </div>
        </div>
      </sui-panel>
      <sui-panel :title="$t('MSG_TIT_ADDR_INFO')">
        <div class="comm_view_wrap">
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_RPRS_EMAIL')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-7">
              <div class="comm_label">
                {{ companyData.companyRepresentativeEmail }}
              </div>
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_RPRS_TEL')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <div class="comm_label">
                {{ companyData.companyRepresentativeTelNumber }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_HMPG')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-7">
              <div class="comm_label">
                {{ companyData.companyHomepageUrl }}
              </div>
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_FAX_NO')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <div class="comm_label">
                {{ companyData.companyFaxNumber }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_ADDR')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-7">
              <div class="comm_label">
                {{ companyData.companyAddress }}
              </div>
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_ZIP')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <div class="comm_label">
                {{ companyData.companyZipCode }}
              </div>
            </div>
          </div>
        </div>
      </sui-panel>
      <sui-panel
        :title="$t('MSG_TIT_RLTD_TASK_SITE')"
      >
        <div class="mrB20" />
        <sui-grid
          ref="taskSiteGrid"
          :columns="gridColumns0"
          :dataset="'ds12'"
          :showCountControl="false"
          :showDisplayCountControl="false"
          :initial-pagesize="3"
          :pagesizeoptions="[3]"
          :multiselect="true"
          :sortable="false"
          :filterable="false"
        >
          <div
            v-if="registrationStateFlag"
            class="btn_wrapL"
          >
            <sui-button
              v-permission:update="this.$options.name"
              type="button"
              class="comm_btn_gridTop"
              @click="addRows"
            >
              {{ $t('MSG_BTN_ROW_ADD') }}
            </sui-button>
            <sui-button
              v-permission:update="this.$options.name"
              type="button"
              class="comm_btn_gridTop"
              @click="deleteRows"
            >
              {{ $t('MSG_BTN_ROW_DEL') }}
            </sui-button>
            <sui-button
              v-permission:update="this.$options.name"
              type="button"
              class="comm_btn_gridTop"
              @click="resetRows"
            >
              {{ $t('MSG_BTN_RESET') }}
            </sui-button>
          </div>
        </sui-grid>
      </sui-panel>
      <div class="comm_btnBot_wrap">
        <div class="btn_wrapL">
          <sui-button
            v-permission:read="this.$options.name"
            type="button"
            class="comm_btn_border"
            @click="onListClick"
          >
            {{ $t('MSG_BTN_LIST') }}
          </sui-button>
        </div>
        <div
          v-if="registrationStateFlag"
          class="btn_wrapR"
        >
          <sui-button
            v-permission:update="this.$options.name"
            type="button"
            class="comm_btn_solid"
            @click="onModClick"
          >
            {{ $t('MSG_BTN_MDFC') }}
          </sui-button>
        </div>
      </div>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMY_00012', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    companyId: {
      type: String,
      default: '',
    },
    targetPageId: {
      type: String,
      default: '',
    },
    siteList: {
      type: Array,
      default() {
        return [];
      },
    },
    taskList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      companyData: {
        nationCode: '',
        companyTradePossibilityYn: '',
        bizDivisionCode: '',
        companyScaleCode: '',
        affiliatedCompanyDivisionCode: '',
        // -----------------CODE----------------
        companyId: '',
        companyName: '',
        companyGlobalName: '',
        corpRegNumber: '',
        corpBizNumber: '',
        companyRepresentativeName: '',
        companyRepresentativeTelNumber: '',
        companyEstablishDTM: '',
        companyFaxNumber: '',
        companyZipCode: '',
        companyAddress: '',
        companyRepresentativeEmail: '',
        bizTypeName: '',
        bizConditionsName: '',
        nationName: '',
        companyHomepageYn: '',
        companyHomepageUrl: '',
        companyEmpValue: '',
        companyScaleValue: '',
        gerpCompanyNumber: '',
        connectionCompanyNumber: '',
        companyAccountGroupCode: '',
        companyAccountGroupName: '',
        companyCloseAccountsDTM: '',
        companyCapitalAmount: '',
        companyCapitalSumAmount: '',
        companyDebtSumAmount: '',
        companyDebtRatioValue: '',
        companyCapitalSurplusAmount: '',
        companyRegistrationStateCode: '',
        companyRegistrationStateName: '',
        companyUseYn: '',
      },
      vendorCreditEvaluationList: [],
      vendorCategoryList: [],
      deleteList: [],
      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_RLTD_TASK'),
        datafield: 'companyRelatedTaskDivCode',
        createwidget: (row, column, value, htmlElement) => {
          this.$nextTick(() => {
            const instance = utils.getGridCellFactory().createCellSelect(row, column, value, htmlElement, {
              optionList: this.taskList,
              checkEditableFunction: this.selectBoxCheckEditableState,
            }, this.ds12, this.$refs.taskSiteGrid);
            instance.getComponentInstance().$on('select', () => {
              const rowindex = instance.getDatasetIndex();
              this.taskSiteDuplicateCheck(rowindex, column);
            });
          });
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_SITE'),
        datafield: 'siteId',
        createwidget: (row, column, value, htmlElement) => {
          this.$nextTick(() => {
            const instance = utils.getGridCellFactory().createCellSelect(row, column, value, htmlElement, {
              optionList: this.siteList,
              checkEditableFunction: this.selectBoxCheckEditableState,
              checkDisabledFunction: this.selectBoxCheckDisabledState,
            }, this.ds12, this.$refs.taskSiteGrid);
            instance.getComponentInstance().$on('select', () => {
              const rowindex = instance.getDatasetIndex();
              this.taskSiteDuplicateCheck(rowindex, column);
            });
          });
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      }, {
        text: this.$t('MSG_TXT_USE_YN'),
        datafield: 'companyTaskSiteUseYn',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellSegmentBox(row, column, value, htmlElement, {
            checkDisabledFunction: this.useYnCheckDisabledState,
          }, this.ds12, this.$refs.taskSiteGrid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: '80px',
      }, {
        text: this.$t('MSG_TXT_RGST_USR'),
        datafield: 'firstRegistrationUserId',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1',
            type: 'link',
            datafieldMap: {
              displayLanguageId: 'dsplLngId',
              knoxId: 'knoxId',
              userName: 'userName',
              userGlobalName: 'userGlobalName',
              departmentName: 'departmentName',
              departmentEnglishName: 'departmentEnglishName',
            },
          }, this.ds12, this.$refs.taskSiteGrid);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
        width: '200px',
      }, {
        text: this.$t('MSG_TXT_RGST_DT'),
        datafield: 'firstRegistrationDTM',
        createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, this.ds12, this.$refs.taskSiteGrid),
        initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),
        width: '150px',
      }],
    };
  },
  computed: {
    // 상생업체 정보 선택 여부 -- 선택 시 true
    connectionCompanyFlag() {
      return !utils.isEmpty(this.companyData.connectionCompanyNumber);
    },
    // 등록상태 -- 등록 완료 시 true
    registrationStateFlag() {
      return utils.isEqual(this.companyData.companyRegistrationStateCode, '6');
    },
    session() {
      return this.$store.getters.userInfo;
    },
  },
  watch: {
    companyId() {
      if (!utils.isEmpty(this.companyId) && utils.isEqual(this.$options.name, this.targetPageId)) {
        // this.reset();
        this.$children[0].$children[1].$children[1].$el.parentElement.parentElement.scrollTop = 0;
        this.companyDataLoad(this.companyId);
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (!utils.isEmpty(this.companyId) && utils.isEqual(this.$options.name, this.targetPageId)) {
        this.companyDataLoad(this.companyId);
      }
    });
  },
  activated() {

  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {
  },
  destroyed() {},
  datasets: [{
    id: 'ds12',
    type: 'local',
    data: 'localdata0',
    datafields: [
      { type: 'string', name: 'dataset-row-id', map: 'dataset-row-id' },
      { type: 'string', name: 'companyId', map: 'companyId' },
      { type: 'string', name: 'companyRelatedTaskDivCode', map: 'companyRelatedTaskDivCode' },
      { type: 'string', name: 'siteId', map: 'siteId' },
      { type: 'string', name: 'companyTaskSiteUseYn', map: 'companyTaskSiteUseYn' },
      { type: 'string', name: 'firstRegistrationUserId', map: 'firstRegistrationUserId' },
      { type: 'string', name: 'firstRegistrationDTM', map: 'firstRegistrationDTM' },
      { type: 'string', name: 'deleteFlag', map: 'deleteFlag' },
      { type: 'string', name: 'dsplLngId', map: 'dsplLngId' },
      { type: 'string', name: 'knoxId', map: 'knoxId' },
      { type: 'string', name: 'userName', map: 'userName' },
      { type: 'string', name: 'userGlobalName', map: 'userGlobalName' },
      { type: 'string', name: 'departmentName', map: 'departmentName' },
      { type: 'string', name: 'departmentEnglishName', map: 'departmentEnglishName' },
    ],
  }],
  methods: {
    // ---------------------------------------detailView Method-----------------------------------
    reset() {
      this.ds12.setRawData([]);
      this.ds12.submit();
      utils.forEach(this.companyData, (value, key) => {
        this.companyData[key] = '';
      });
      this.vendorCreditEvaluationList = [];
      this.vendorCategoryList = [];
      this.deleteList = [];
    },
    onListClick() {
      if (this.isDataChanged()) {
        utils.messageBox('confirm', this.$t('MSG_ALT_NOT_SAVE_DATA'), null, () => {
          this.reset();
          this.$emit('mainViewLoad');
        });
      } else {
        this.reset();
        this.$emit('mainViewLoad');
      }
    },
    companyDataLoad(companyId) {
      http.request(this.$options.name, 'DTS_CMY_00048', {
        path: {
          'company-id': companyId,
        },
      }).then(res => {
        this.setCompanyDataByCompanyData(res.data);
      }).catch(error => {
        console.log(error);
      });
    },
    setCompanyDataByCompanyData(data) {
      utils.forEach(this.companyData, (value, key) => {
        if (utils.has(data, key)) {
          this.companyData[key] = data[key];
        }
      });
      this.companyData.companyEstablishDTM = utils.toStringByFormat(data.companyEstablishDTM, 'YYYY-MM-DD');
      utils.forEach(data.vendorTaskSiteList, row => {
        utils.assign(row, row.firstRegistrationUserInfo);
      });
      this.ds12.setRawData(data.vendorTaskSiteList);
    },
    selectBoxCheckEditableState(rowData) {
      return utils.isEmpty(rowData) ? true : utils.isEmpty(rowData.companyId);
      // return true;
    },
    selectBoxCheckDisabledState() {
      return true;
    },
    useYnCheckDisabledState() {
      return !this.registrationStateFlag;
    },
    selectRow(index) {
      const [selected] = this.ds12.getSelectedIndexes();
      if (selected !== index) {
        this.ds12.setSelectedIndex(index);
      }
    },
    onModClick() {
      const saveData = this.ds12.data;
      const result = this.validation(saveData);
      if (result.valid) {
        this.saveAction(saveData);
      } else {
        utils.messageBox('warning', result.message, null, () => {
          this.$refs.taskSiteGrid.setFocus(result.row, result.column);
        });
      }
    },
    validation(saveData) {
      const result = {
        valid: true,
        message: '',
        row: '',
        column: '',
      };
      utils.forEach(saveData, (data, index) => {
        if (utils.isEmpty(data.companyRelatedTaskDivCode)) {
          result.valid = false;
          result.message = utils.strFormat(this.$t('MSG_ALT_ROW_SELECT'), index + 1, this.$t('MSG_TXT_RLTD_TASK'));
          result.row = index;
          result.column = 'companyRelatedTaskDivCode';
          return false;
        }
        if (utils.isEmpty(data.siteId)) {
          result.valid = false;
          result.message = utils.strFormat(this.$t('MSG_ALT_ROW_SELECT'), index + 1, this.$t('MSG_TXT_SITE'));
          result.row = index;
          result.column = 'siteId';
          return false;
        }
        return null;
      });
      return result;
    },
    saveAction(saveData) {
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_SAVE'), null, () => {
        http.request(this.$options.name, 'DTS_CMY_00050', {
          path: {
            'company-id': this.companyData.companyId,
          },
          data: saveData,
        }, true).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_SAVE_DATA'), null, () => {
            this.ds12.submit();
            this.companyDataLoad(this.companyData.companyId);
          });
        }).catch(error => {
          // 관련업무 사업장 리스트가 빈 경우
          const { data } = error;
          if (utils.isEqual(data.errorType, 'B')) {
            utils.messageBox('error', data.errorMessage, null, this.resetRows);
          } else {
            utils.messageBox('error', data.errorMessage, { title: data.exceptionLogId, content: data.exception });
          }
        });
      });
    },
    addRows() {
      this.ds12.addRows([{
        companyId: '',
        companyRelatedTaskDivCode: '',
        siteId: this.session.siteId,
        companyTaskSiteUseYn: 'Y',
      }]);
      const lastIndex = this.ds12.data.length - 1;
      this.$refs.taskSiteGrid.ensurerowvisible(lastIndex);
    },
    deleteRows() {
      const rowIds = this.ds12.getSelectedRowIds();
      this.ds12.deleteRowsByRowId(rowIds);
    },
    resetRows() {
      this.ds12.reset();
      this.deleteList = [];
    },
    taskSiteDuplicateCheck(rowindex, column) {
      const { siteId, companyRelatedTaskDivCode } = this.ds12.data[rowindex];
      const findindex = utils.findIndex(this.ds12.data, { siteId, companyRelatedTaskDivCode });
      if (findindex !== rowindex && findindex > -1) {
        utils.messageBox('warning', this.$t('MSG_ALT_EXIST_SITE'), null, () => {
          this.ds12.setData(rowindex, column, '');
        });
      }
    },
  },
};
</script>
<style scoped>
</style>
